export function argbIntToHex(rgb: number | null | undefined): string | null {
  if (rgb === null || rgb === undefined) return null;
  const hex = (rgb & 0xffffff).toString(16).padStart(6, '0');
  return `#${hex}`;
}

/**
 * Returns a readable foreground color (#1f2937 dark or #ffffff white) for text
 * placed on top of the given `#rrggbb` background, based on perceived luminance
 * (ITU-R BT.601). Used so a table card painted with an arbitrary POS status
 * color keeps its text legible. Returns null when the input is null.
 */
export function contrastText(hex: string | null | undefined): string | null {
  if (!hex) return null;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 150 ? '#1f2937' : '#ffffff';
}
